// extracted by mini-css-extract-plugin
export var productImage = "_xs-0";